import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import configs from 'configs';

import { getSustainabilityIndexByMonthlyRateAndDeposit, getSustainabilityMessageByMonthlyRateAndDeposit } from 'utils/prescoringTool';

import { Affix, Button, Modal, Checkbox, Radio, Row, Col } from 'antd';
import { withOfferSelectorReducer, withOfferSelectorSaga } from './withReducer';

import messages from './messages';

import {
  offerSelected,
  selectServices,
  selectAccessories,
  selectColors,
  selectAccessoriesCodes,
  selectColorCodes,
  calculateNewMonthlyRate,
  resetFees,
} from './actions';

import {
  makeSelectAccessoriesSelector,
  makeSelectColorsSelector,
  makeSelectServicesSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
  makeSelectMonthlyRateSelector,
  makeSelectFeesSelector,
  getServicePriceByOfferParams,
} from './selectors';

import { makeSelectCheckResponse } from '../PrescoringTool/selectors'

import { SelectOption, SelectOptions, InteractiveList } from '../UIKit';
import { default as OfferStickyPrice } from '../OfferPrice/sticky';
import './styles.scss';
import 'antComponentsStyle';

class CustomizeOffer extends React.Component {
  constructor(props) {
    super(props);

    this.QuotationInitializerRef = React.createRef();

    this.state = {
      durations: [],
      distances: [],
      deposits: [],
      bundles: [],
      selected: {
        distance: props.distance,
        duration: props.duration,
        bundle: props.bundle,
        deposit: props.deposit,
      },
      selectedOffer: {},
      selectedAdditionalServices: [],
      modalVisible: false,
    };

    this.handleOnDurationClick = this.handleOnDurationClick.bind(this);
    this.handleOnDistanceClick = this.handleOnDistanceClick.bind(this);
    this.handleOnDepositClick = this.handleOnDepositClick.bind(this);
    this.handleOnBundleClick = this.handleOnBundleClick.bind(this);
    this.handleOnServiceClick = this.handleOnServiceClick.bind(this);
    this.handleOnRemoveAllClick = this.handleOnRemoveAllClick.bind(this);
    this.handleOnItemClick = this.handleOnItemClick.bind(this);
    this.handleOnOptionClick = this.handleOnOptionClick.bind(this);
    this.handleOnColorClick = this.handleOnColorClick.bind(this);
  }

  componentDidMount() {
    this.initOffers();
  }

  componentDidUpdate(prevProps) {
    const { offerCode, fees } = this.props
    const { selected } = this.state
    const duration = selected.duration >= 0 ? selected.duration : this.props.duration;
    const distance = selected.distance >= 0 ? selected.distance : this.props.distance;
    const deposit = selected.deposit >= 0 ? selected.deposit : this.props.deposit;
    const bundle = selected.bundle && selected.bundle !== '' ? selected.bundle : this.props.bundle;

    if (prevProps.offerCode !== offerCode){
      this.initOffers();
    }

    if (prevProps.fees.finalMonthlyRate !== fees.finalMonthlyRate) {
      this.selectDepositsFromChilds({ duration, distance, bundle }, deposit, this.state.selectedAdditionalServices);
    }

    this.calculateFinalPrice();
  }

  initOffers() {
    const {
      deposit,
      distance,
      duration,
      bundle,
      tag,
      secondaryTag,
    } = this.props;

    // generate choices
    this.selectDurationsFromChilds(duration);
    this.selectDistancesFromChilds(distance);
    this.selectBundlesFromChilds(bundle);
    this.selectDepositsFromChilds({ duration, distance, bundle }, deposit);

    const selectedOffer = this.findChildOffer(
      distance,
      duration,
      deposit,
      bundle,
    );

    this.setState(
      {
        selectedOffer,
        // selectedAdditionalServices: [],
      },
      () => {
      this.props.selectOffer({
        ...selectedOffer,
        tag,
        secondaryTag,
      });
    });
  }

  selectDurationsFromChilds(selected = -1) {
    let durations = new Set();
    this.props.childOffers.map(offer => durations.add(parseInt(offer.duration)));
    durations = [...new Set(durations)].sort();

    let durationsObj = [];
    durations.forEach(elem => {
      durationsObj.push({
        value: elem,
        label: parseInt(elem).toLocaleString('it'),
        unit: 'mesi',
        selected: elem === selected,
      });
    });

    durationsObj = [...new Set(durationsObj)].sort();

    this.setState({ durations: durationsObj });
  }

  selectDistancesFromChilds(selected = -1) {
    let distances = new Set();
    this.props.childOffers.map(offer => distances.add(parseInt(offer.distance)));
    distances = [...new Set(distances)].sort((a, b) => a - b);

    const distancesObj = [];
    distances.forEach(elem => {
      distancesObj.push({
        value: elem,
        label: parseInt(elem).toLocaleString('it'),
        description: 'Km/Anno',
        selected: elem === selected,
        disabled: !this.props.childOffers.find(childOffer => childOffer.distance === elem && childOffer.duration === this.state.selected.duration)
      });
    });

    this.setState({ distances: distancesObj });
  }

  selectBundlesFromChilds(selected = -1) {
    let bundles = new Set();
    this.props.childOffers.map(offer => bundles.add(offer.bundle));
    bundles = [...new Set(bundles)];

    const bundlesLight = bundles.filter(bundle => bundle && bundle.includes('Light')).sort();
    const bundlesNotLight = bundles.filter(bundle => bundle && !bundle.includes('Light')).sort();

    bundles = [...bundlesLight, ...bundlesNotLight];

    const bundlesObj = [];
    bundles.forEach(elem => {
      if (elem !== undefined && elem !== null) {
        bundlesObj.push({
          value: elem,
          label: elem,
          description: '',
          selected: elem === selected,
          disabled:
            !this.props.childOffers.find(childOffer =>
              childOffer.bundle === elem
              && childOffer.deposit === this.state.selected.deposit
              && childOffer.duration === this.state.selected.duration
              && childOffer.distance === this.state.selected.distance
              )
        });
      }
    });

    this.setState({ bundles: bundlesObj });
  }

  selectDepositsFromChilds(selectedState = {}, selected = -1, selectedAdditionalServices = []) {
    const { duration, distance, bundle } = selectedState;
    const { childOffers, fees, selectMonthlyRate } = this.props;
    let deposits = new Set();

    childOffers.map(offer => deposits.add(parseInt(offer.deposit)));
    deposits = [...new Set(deposits)].sort((a, b) => a - b);

    const totAdditionalServicesCost = selectedAdditionalServices.reduce((prevValue, additionalService) => prevValue + additionalService.price, 0)

    const depositsObj = [];

    deposits.forEach(elem => {
      const childOffer = childOffers.filter(item =>
        parseInt(item.distance) === distance &&
        parseInt(item.duration) === duration &&
        item.bundle === bundle &&
        parseInt(item.deposit) === elem
      )[0];

      if (
        childOffer !== undefined &&
        childOffer.hasOwnProperty('monthly_rate') &&
        childOffer.hasOwnProperty('ref')
      ) {
        let monthly_rate = childOffer.monthly_rate;

        if (childOffer.special_rate > 0) {
          monthly_rate = Math.min(monthly_rate, childOffer.special_price);
        }

        monthly_rate += totAdditionalServicesCost;

        let description = `${monthly_rate}€ al mese`

        if (fees.finalMonthlyRate > 0 && fees.finalMonthlyRate !== selectMonthlyRate) {
          const newMonthlyRate = monthly_rate + (fees.finalMonthlyRate - selectMonthlyRate)
          description = <><strike className="text-muted">{monthly_rate}€</strike> {parseInt(newMonthlyRate)}€ al mese</>
        }

        depositsObj.push({
          value: elem,
          label: parseInt(elem).toLocaleString('it'),
          unit: '€',
          description,
          selected: elem === selected,
          disabled:
            !childOffers.find(childOffer =>
              childOffer.deposit === elem
              && childOffer.duration === this.state.selected.duration
              && childOffer.distance === this.state.selected.distance
              && childOffer.bundle === this.state.selected.bundle
              )
        });
      }
    });

    this.setState({ deposits: depositsObj });
  }

  handleOnClick = e => {
    e.preventDefault();
    this.props.open();
  };

  handleOnDurationClick(value) {
    const selected = {...this.state.selected, duration: value};

    this.setState({ selected }, () => {
      this.selectDurationsFromChilds(value);
      this.selectDistancesFromChilds(selected.distance);

      if (!this.state.bundles.length) {
        this.selectBundlesFromChilds(selected.bundle);
      }

      this.selectDepositsFromChilds(selected, selected.deposit, this.state.selectedAdditionalServices);

      const selectedOffer = this.findChildOffer(
        selected.distance,
        value,
        selected.deposit,
        selected.bundle,
      );

      if (selectedOffer && selectedOffer.ref) {
        this.setState({ selectedOffer }, () => {
          this.props.selectOffer({ ...selectedOffer });

          // resetto il canone personalizzato da over commission
          this.props.resetFees();
        });
      } else {
        this.setState({ selectedOffer: {} });
      }

      setTimeout(() => {
        this.updateSustainabilityIndexesAfterHandlers();
      }, 200);

      this.calculateFinalPrice();
    });
  }

  handleOnDistanceClick(value) {
    const selected = {...this.state.selected, distance: value};

    this.setState({ selected }, () => {
      this.selectDistancesFromChilds(value);

      if (this.state.bundles.length) {
        this.selectBundlesFromChilds(selected.bundle);
      }

      this.selectDepositsFromChilds(selected, selected.deposit, this.state.selectedAdditionalServices);

      const selectedOffer = this.findChildOffer(
        value,
        selected.duration,
        selected.deposit,
        selected.bundle,
      );

      if (selectedOffer && selectedOffer.ref) {
        this.setState({ selectedOffer }, () => {
          this.props.selectOffer({ ...selectedOffer });

          // resetto il canone personalizzato da over commission
          this.props.resetFees();
        });
      } else {
        this.setState({ selectedOffer: {} });
      }

      setTimeout(() => {
        this.updateSustainabilityIndexesAfterHandlers();
      }, 200);

      this.calculateFinalPrice();
    });
  }

  handleOnBundleClick(value) {
    const selected = {...this.state.selected, bundle: value};

    this.setState({ selected }, () => {
      this.selectBundlesFromChilds(value);
      this.selectDepositsFromChilds(selected, selected.deposit, this.state.selectedAdditionalServices);

      const selectedOffer = this.findChildOffer(
        selected.distance,
        selected.duration,
        selected.deposit,
        value,
      );

      if (selectedOffer && selectedOffer.ref) {
        this.setState({ selectedOffer }, () => {
          this.props.selectOffer({ ...selectedOffer });

          // resetto il canone personalizzato da over commission
          this.props.resetFees();
        });
      } else {
        this.setState({ selectedOffer: {} });
      }

      setTimeout(() => {
        this.updateSustainabilityIndexesAfterHandlers();
      }, 200);

      this.calculateFinalPrice();
    });
  }

  handleOnDepositClick(value) {
    if (this.state.selected && this.state.selected.deposit !== value) {
      const selected = { ...this.state.selected, deposit: value };

      this.setState({ selected }, () => {
        this.selectDepositsFromChilds(selected, value, this.state.selectedAdditionalServices);

        const selectedOffer = this.findChildOffer(
          selected.distance,
          selected.duration,
          value,
          selected.bundle,
        );

        this.setState({ selectedOffer }, () => {
          this.props.selectOffer({ ...selectedOffer });

          // resetto il canone personalizzato da over commission
          this.props.resetFees();

          setTimeout(() => {
            this.updateSustainabilityIndexesAfterHandlers();
          }, 200);
        });

        this.calculateFinalPrice();
      });
    }
  }

  handleOnServiceClick(value, price = null, quantity = null) {
    const { services, resetFees } = this.props;

    let { selected, selectedAdditionalServices, selectedOffer } = this.state;
    const service = services.find(obj => obj.id === value);

    if (price !== null) {
      selectedAdditionalServices = selectedAdditionalServices.filter(selectedAdditionalService => selectedAdditionalService.id !== value);
      selectedAdditionalServices.push({...service, price, quantity});
    } else {
      if (selectedAdditionalServices.some(selectedAdditionalService => selectedAdditionalService.id === service.id)) {
        selectedAdditionalServices = selectedAdditionalServices.filter(selectedAdditionalService => selectedAdditionalService.id !== value);
      } else {
        selectedAdditionalServices.push(service);
      }
    }

    this.setState({ selectedAdditionalServices }, () => {
      this.props.selectServices(selectedAdditionalServices);

      this.selectDepositsFromChilds(selected, selected.deposit, this.state.selectedAdditionalServices);

      // resetto il canone personalizzato da over commission
      resetFees();

      setTimeout(() => {
        this.updateSustainabilityIndexesAfterHandlers();
      }, 200);
    });
  }

  updateSustainabilityIndexesAfterHandlers() {
    const { selectedOffer } = this.state;
    const { selectMonthlyRate, fees } = this.props;
    let { prescoringResponse } = this.props;

    prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

    if (prescoringResponse && prescoringResponse.hasOwnProperty('chance')) {
      const { monthlyRateMax, depositRequired, thresholdMonthlyRateMax } = prescoringResponse;
      const finalMonthlyRate = fees.finalMonthlyRate && fees.finalMonthlyRate !== selectMonthlyRate ? fees.finalMonthlyRate : selectMonthlyRate;

      const sustainabilityIndex = getSustainabilityIndexByMonthlyRateAndDeposit(monthlyRateMax, finalMonthlyRate, depositRequired, selectedOffer.deposit || 0, thresholdMonthlyRateMax);
      const sustainabilityMessage = getSustainabilityMessageByMonthlyRateAndDeposit(monthlyRateMax, finalMonthlyRate, depositRequired, selectedOffer.deposit || 0, thresholdMonthlyRateMax);

      this.setState({
        selectedOffer: {
          ...selectedOffer,
          sustainabilityIndex,
          sustainabilityMessage,
        }
      });
    }
  }

  /**
   *
   * @param distance
   * @param duration
   * @param deposit
   * @returns {*}
   */
  findChildOffer(distance, duration, deposit, bundle) {
    const childOffer = this.props.childOffers.filter(
      item =>
        parseInt(item.deposit) === deposit &&
        parseInt(item.distance) === distance &&
        parseInt(item.duration) === duration &&
        (!bundle || item.bundle === bundle),
    );

    return childOffer && childOffer.length ? childOffer[0] : null
  }

  /**
   *
   * @param selectedOffer
   * @param services
   * @param accessories
   * @param selectedColors
   * @returns {undefined|number}
   */
  calculateFinalPrice() {
    const {
      selectedOffer,
      selectedAdditionalServices,
    } = this.state;
    const {
      accessories,
      selectedColors,
    } = this.props;

    const selectedServices = selectedAdditionalServices

    if (
      selectedOffer &&
      selectedOffer.hasOwnProperty('ref') &&
      selectedOffer.hasOwnProperty('monthly_rate')
    ) {
      const servicesPrice = selectedServices.reduce(
        (sum, service) => sum + service.price,
        0,
      );
      const accessoriesPrice =
        accessories.reduce((sum, accessory) => sum + accessory.price, 0) / selectedOffer.duration;
      const colorsPrice =
        selectedColors.reduce((sum, color) => sum + color.price, 0) / selectedOffer.duration;
      const newMonthlyRate = parseFloat(
        selectedOffer.monthly_rate +
        servicesPrice +
        accessoriesPrice +
        colorsPrice,
      );

      setTimeout(() => {
        this.props.calculateNewMonthlyRate(newMonthlyRate);
      }, 100);
    } else {
      this.props.calculateNewMonthlyRate();
    }
  }

  /**
   * Handle remove all click
   */
  handleOnRemoveAllClick() {
    this.props.selectAccessoriesCodes([]);
    this.props.selectAccessories([]);
    this.props.selectColorCodes([]);
    this.props.selectColors([]);
  }

  /**
   *
   * @param code
   */
   handleOnItemClick(code) {
    const {
      accessories,
      selectedAccessoriesCodes,
      colors,
      selectedColorsCodes,
    } = this.props;

    // handle options
    const selectedOptions = new Set(selectedAccessoriesCodes);
    selectedOptions.delete(code);
    this.props.selectAccessoriesCodes([...selectedOptions]);
    const selected = accessories.filter(item => selectedOptions.has(item.code));
    this.props.selectAccessories(selected);

    // handle colors
    const selectedColors = new Set(selectedColorsCodes);
    selectedColors.delete(code);
    this.props.selectColorCodes([...selectedColors]);
    const selectedColor = colors.filter(item => selectedColors.has(item.code));
    this.props.selectColors(selectedColor);
  }


  handleOnOptionClick(e) {
    const { selectedAccessoriesCodes, options } = this.props;
    const selectedOptions = new Set(selectedAccessoriesCodes);
    const value = e.target.value;

    if (selectedOptions.has(value)) {
      selectedOptions.delete(value);
    } else {
      selectedOptions.add(value);
    }
    this.props.selectAccessoriesCodes([...selectedOptions]);
    const selected = options.filter(item => selectedOptions.has(item.code));
    this.props.selectAccessories(selected);
  }

  handleOnColorClick(e) {
    const { colors } = this.props;
    const value = e.target.value;

    const selectedColors = new Set();
    selectedColors.add(value);

    this.props.selectColorCodes([...selectedColors]);
    const selected = colors.filter(item => selectedColors.has(item.code));
    this.props.selectColors(selected);
  }

  convertToList(items) {
    const { selectedAccessoriesCodes } = this.props;
    const selectedOptions = new Set(selectedAccessoriesCodes);

    let result = [];
    items.map((item, key) => {
      const elem = {
        price: item.price,
        code: item.code,
        description: item.description,
        short_description: item.short_description,
        standard_description: item.standard_description,
        selected: selectedOptions.has(item.code),
      };
      const group = result.filter(e => e.group === item.group_code);
      const obj = {
        group: item.group_code,
        title: item.group,
      };
      if (Object.keys(group).length === 0) {
        obj.items = [elem];
      } else {
        const list = group[0].items;
        list.push(elem);
        obj.items = list;
        // remove all preview objects
        result = result.filter(res => res.group !== obj.group);
      }
      result.push(obj);
    });
    return result;
  }

  showModal = () => {
    this.setState({ modalVisible: true });
  };

  handleModalOk = () => {
      this.setState({ modalVisible: false });
  };

  /**
   *
   * @returns {*}
   */
  render() {
    const {
      carName,
      carType,
      accessories,
      colors,
      options,
      selectedColors,
      selectedColorsCodes,
      selectedServices,
      selectedAccessoriesCodes,
      hasVariations,
      referenceCode,
      selectMonthlyRate,
      fees,
      tag,
      equippedOptionals,
    } = this.props;

    const {
      durations,
      distances,
      deposits,
      bundles,
      selectedOffer,
      selectedAdditionalServices,
    } = this.state;

    let { services, prescoringResponse } = this.props;
    prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

    services = services.map(service => ({
      ...service,
      price: tag === 'Catalogo' ? service.price : getServicePriceByOfferParams(service, {offer: selectedOffer})
    }))

    let label = '';
    if (!hasVariations) {
      label = messages.fixed.defaultMessage;
    }

    const price = fees.finalMonthlyRate && fees.finalMonthlyRate !== selectMonthlyRate ? fees.finalMonthlyRate : selectMonthlyRate;


    /* gestisco la sostenibilità dell'offerta (semaforo e messaggio) in base ai vari casi */

    const selectedOfferDerived = Object.assign({}, selectedOffer);

    const { monthlyRateMax, depositRequired, chance, description, thresholdMonthlyRateMax } = prescoringResponse;
    const { sustainabilityIndex: offerSustainabilityIndexOriginal, sustainabilityMessage: offerSustainabilityMessageOriginal, deposit } = selectedOffer;

    if (offerSustainabilityIndexOriginal !== undefined && offerSustainabilityIndexOriginal !== null) {
      selectedOfferDerived.sustainabilityIndex = offerSustainabilityIndexOriginal;
      selectedOfferDerived.sustainabilityMessage = offerSustainabilityMessageOriginal || getSustainabilityMessageByMonthlyRateAndDeposit(monthlyRateMax, price, depositRequired, deposit || 0, thresholdMonthlyRateMax);
    } else if (chance !== null && chance >= 0) {
      if (monthlyRateMax > 0) {
        selectedOfferDerived.sustainabilityIndex = Math.min(chance, getSustainabilityIndexByMonthlyRateAndDeposit(monthlyRateMax, price, depositRequired, deposit, thresholdMonthlyRateMax));
      } else {
        selectedOfferDerived.sustainabilityIndex = chance;
      }

      selectedOfferDerived.sustainabilityMessage = description;
    }

    if (fees.finalMonthlyRate && fees.finalMonthlyRate !== selectMonthlyRate && monthlyRateMax > 0) {
      // sovrascrivo indici di sostenibilità visto che il canone mensile è aumentato per l'over commission
      const newIndex = getSustainabilityIndexByMonthlyRateAndDeposit(monthlyRateMax, fees.finalMonthlyRate, depositRequired, deposit || 0, thresholdMonthlyRateMax);

      if (newIndex !== null) {
        selectedOfferDerived.sustainabilityIndex = newIndex;
        selectedOfferDerived.sustainabilityMessage = getSustainabilityMessageByMonthlyRateAndDeposit(monthlyRateMax, fees.finalMonthlyRate, depositRequired, deposit || 0, thresholdMonthlyRateMax);
      }
    }

    if (chance !== null && chance >= 0 && (!selectedOfferDerived.sustainabilityMessage || !selectedOfferDerived.sustainabilityMessage.length)) {
      selectedOfferDerived.sustainabilityMessage = 'CONGRATULATIONS_THIS_OFFER';
    }

    /* fine gestione sostenibilità */


    const optionalsAndColors = [
      ...this.convertToList(colors),
      ...this.convertToList(options),
    ];
    const optionalsAndColorsSelected = [...selectedColors, ...accessories];

    const selectedBundle = bundles.length ? bundles.find(bundle => bundle.selected === true) : null;

    const bundleDescriptionVehicleTypeIndex = (carType && carType === 'commerciale') ? 'businessVehicle' : 'default';

    return (
      <div id="OfferDetails">
        <div className="detail-title">
          <FormattedMessage {...messages.title} /> {carName}
        </div>
        <div className="detail-description">
          {referenceCode}
        </div>
        <Affix className="OfferDetails-Sticky" offsetTop={-6}>
          <OfferStickyPrice
            price={price}
            offer={selectedOfferDerived}
            accessories={accessories}
            selectedColors={selectedColors}
            services={selectedServices}
            equippedOptionals={equippedOptionals}
            fees={fees}
          />
        </Affix>
        <div
          className="detail-items"
        >
          <SelectOption
            title={messages.duration.defaultMessage}
            items={durations}
            active
            withBorder={false}
            callback={this.handleOnDurationClick}
            colSize={4}
            label={label}
            id="durata"
          />

          <SelectOption
            title={messages.distance.defaultMessage}
            items={distances}
            active={durations.some(item => item.selected === true)}
            callback={this.handleOnDistanceClick}
            colSize={4}
            label={label}
            id="distanza"
          />

          {bundles && bundles.length > 0 &&
          <>
            <SelectOption
              title={messages.bundle.defaultMessage}
              items={bundles}
              active={distances.some(item => item.selected === true && item.disabled === false)}
              callback={this.handleOnBundleClick}
              colSize={4}
              label={label}
              id="bundle"
            />
            <div className="mb-2">
              {
                selectedBundle && configs.bundlesDescription.hasOwnProperty(selectedBundle.value) ?
                  configs.bundlesDescription[selectedBundle.value][bundleDescriptionVehicleTypeIndex] || ''
                  : ''
              }
            </div>
          </>
          }

          <SelectOption
            title={messages.deposit.defaultMessage}
            items={deposits}
            active={
              (bundles && bundles.length)
              ? bundles.some(item => item.selected === true)
              : distances.some(item => item.selected === true)
            }
            callback={this.handleOnDepositClick}
            colSize={4}
            label={label}
            id="anticipo"
          />

          {services.length > 0 &&
            <SelectOptions
              title={messages.services.defaultMessage}
              items={services}
              selected={selectedAdditionalServices}
              callback={this.handleOnServiceClick}
              id="services"
            />
          }

          {(configs.optionalsAndColors && optionalsAndColors.length) ?
            <div className="Select-Options with-border">
            <h6>
            {messages.optionalsAndColorsLabel.defaultMessage}
            </h6>
            {optionalsAndColorsSelected.length ?
              <InteractiveList
                  withBorder={false}
                  withPlaceholder={false}
                  items={optionalsAndColorsSelected.length ? optionalsAndColorsSelected : []}
                  removeAllCallback={this.handleOnRemoveAllClick}
                  itemCallback={this.handleOnItemClick}
                />
              :
                <span className="description">{messages.optionalsAndColorsDescription.defaultMessage}</span>
              }
              <Row>
                <Col md={12}>
                  {optionalsAndColorsSelected.length !== 0 ?
                <Button
                  className="mx-auto mt-4 text-underline btn-link-no-padding"
                  size="large"
                  type="link"
                  onClick={this.handleOnRemoveAllClick}
                >
                  Rimuovi tutti
                </Button> : null
              }

              </Col>
                <Col md={12} className="text-right">
                <Button
                className="mx-auto mt-4"
                size="large"
                onClick={this.showModal}
                style={{ width: '220px' }}
              >
                Scegli dalla lista...
              </Button>
              </Col>
              </Row>
              <Modal
                title={<h6>{messages.optionalsAndColorsLabel.defaultMessage}</h6>}
                className="offer-optionals-colors"
                visible={this.state.modalVisible}
                onCancel={this.handleModalOk}
                footer={[
                  <Button key="submit" onClick={this.handleModalOk} size="large">
                    Fatto
                  </Button>,
                  <Button
                    key="reset"
                    onClick={this.handleOnRemoveAllClick}
                    size="large"
                    type="link"
                    className="pull-left text-underline btn-link-no-padding"
                    disabled={optionalsAndColorsSelected.length === 0}
                  >
                    Rimuovi tutti
                  </Button>
                ]}
                width={800}
              >
                {
                optionalsAndColors.map(optionalAndColorGroup =>
                  <div key={optionalAndColorGroup.group} className="ui-list">
                    <strong className="title">{optionalAndColorGroup.title}</strong>
                    <ul>
                      {optionalAndColorGroup.title === 'Vernici' ?
                      optionalAndColorGroup.items.map(item =>
                        <li key={item.description} className="item">
                          <Radio.Group
                            onChange={this.handleOnColorClick}
                            value={selectedColorsCodes.length ? selectedColorsCodes[0] : null}
                          >
                            <Radio value={item.code}>
                              <span>{item.description}</span>
                              <div className="float-right nowrap"><span className="font-weight-bold">{parseInt(item.price).toLocaleString('it')}</span> €</div>
                            </Radio>
                          </Radio.Group>
                        </li>
                      )
                      :
                      optionalAndColorGroup.items.map(item =>
                        <li key={item.description} className="item">
                          <Checkbox
                            onChange={this.handleOnOptionClick}
                            value={item.code}
                            checked={selectedAccessoriesCodes.length && selectedAccessoriesCodes.indexOf(item.code) >= 0}
                          >
                            <span>{item.description}</span>
                            <div className="float-right nowrap"><span className="font-weight-bold">{parseInt(item.price).toLocaleString('it')}</span> €</div>
                          </Checkbox>
                        </li>
                      )
                      }
                    </ul>
                  </div>
                )
                }
              </Modal>

            </div>
            : null
          }
        </div>
        <div id="OfferDetails-padding" />
      </div>
    );
  }
}
CustomizeOffer.defaultProps = {
  childOffers: [],
  offerCode: '',
  hasVariations: true,
};

CustomizeOffer.propTypes = {
  deposit: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  distance: PropTypes.number.isRequired,
  bundle: PropTypes.string,
  carName: PropTypes.string.isRequired,
  carPower: PropTypes.number.isRequired,
  carType: PropTypes.string,
  childOffers: PropTypes.array,
  offerCode: PropTypes.string,
  hasVariations: PropTypes.bool,
  colors: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  services: PropTypes.array.isRequired,
  tag: PropTypes.string,
  secondaryTag: PropTypes.string,
};

export function mapDispatchToProps(dispatch) {
  return {
    selectOffer: offer => dispatch(offerSelected(offer)),
    calculateNewMonthlyRate: monthlyRate => dispatch(calculateNewMonthlyRate(monthlyRate)),
    selectServices: services => dispatch(selectServices(services)),
    selectAccessories: accessories => dispatch(selectAccessories(accessories)),
    selectAccessoriesCodes: codes => dispatch(selectAccessoriesCodes(codes)),
    selectColors: colors => dispatch(selectColors(colors)),
    selectColorCodes: codes => dispatch(selectColorCodes(codes)),
    resetFees: () => dispatch(resetFees()),
  };
}

const mapStateToProps = createStructuredSelector({
  accessories: makeSelectAccessoriesSelector(),
  selectedColors: makeSelectColorsSelector(),
  selectedAccessoriesCodes: makeSelectAccessoriesCodesSelector(),
  selectedColorsCodes: makeSelectColorCodesSelector(),
  selectedServices: makeSelectServicesSelector(),
  selectMonthlyRate: makeSelectMonthlyRateSelector(),
  fees: makeSelectFeesSelector(),
  prescoringResponse: makeSelectCheckResponse(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withOfferSelectorReducer,
  withOfferSelectorSaga,
  withConnect,
)(CustomizeOffer);
